export default __webpack_public_path__ + "static/media/shoes.67c947da.webp";